import component from "./DateInput";
export default component;
